// import React from 'react';

// import HTML from '../assets/html.png';
// import CSS from '../assets/css.png';
// import JavaScript from '../assets/javascript.png';
// import ReactImg from '../assets/react.png';
// import Node from '../assets/node.png';
// import FireBase from '../assets/firebase.png';
// import GitHub from '../assets/github.png';
// import Tailwind from '../assets/tailwind.png';
// import Mongo from '../assets/mongo.png';
// import HighlightText from '../data/HighlightText';
// import Express1 from '../assets/Express1.png'
// import Cp from "../assets/Cp.png"
// import Dsa1 from "../assets/Dsa1.png"

// const Skills = () => {
//   return (
//     <div name='skills' className='w-full h-screen bg-[#0a192f] text-gray-300 pt-[100px]'>
//       {/* Container */}
//       <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
//           <div>
//               <p className='text-4xl font-bold inline border-b-4 border-pink-600  '>
//               <HighlightText text={"Skills"}/>
//               </p>
//               <p className='py-4 text-white'>
//               These are the technologies I've worked with
//              </p>
//           </div>

//           <div className='w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8'>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={HTML} alt="HTML icon" />
//                   <p className='my-4'>   <HighlightText text={"HTML"}/></p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={CSS} alt="HTML icon" />
//                   <p className='my-4'>  <HighlightText text={"CSS"}/></p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={JavaScript} alt="HTML icon" />
//                   <p className='my-4'>  <HighlightText text={"JAVASCRIPT "}/></p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={ReactImg} alt="HTML icon" />
//                   <p className='my-4'> <HighlightText text={"REACT "}/></p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={GitHub} alt="HTML icon" />
//                   <p className='my-4'> <HighlightText text={" GITHUB"}/> </p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={Node} alt="HTML icon" />
//                   <p className='my-4'> <HighlightText text={" NODE JS"}/></p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={Mongo} alt="HTML icon" />
//                   <p className='my-4'> <HighlightText text={"MONGO DB "}/></p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={Tailwind} alt="HTML icon" />
//                   <p className='my-4'> <HighlightText text={"TAILWIND"}/></p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={Express1} alt="HTML icon" />
//                   <p className='my-4'> <HighlightText text={" Express js"}/></p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={FireBase} alt="HTML icon" />
//                   <p className='my-4'> <HighlightText text={" FIREBASE"}/></p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={Cp} alt="HTML icon" />
//                   <p className='my-4'> <HighlightText text={"C++ "}/></p>
//               </div>
//               <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
//                   <img className='w-20 mx-auto' src={Dsa1} alt="HTML icon" />
//                   <p className='my-4'> <HighlightText text={" Data Structure  "}/></p>
//               </div>
//           </div>
//       </div>
//     </div>
//   );
// };

// export default Skills;
import React from 'react';

import HTML from '../assets/html.png';
import CSS from '../assets/css.png';
import JavaScript from '../assets/javascript.png';
import ReactImg from '../assets/react.png';
import Node from '../assets/node.png';
import FireBase from '../assets/firebase.png';
import GitHub from '../assets/github.png';
import Tailwind from '../assets/tailwind.png';
import Mongo from '../assets/mongo.png';
import HighlightText from '../data/HighlightText';
import Express1 from '../assets/Express1.png';
import Cp from "../assets/Cp.png";
import Dsa1 from "../assets/Dsa1.png";

const Skills = () => {
  return (
    <div name='skills' className='w-full min-h-screen bg-[#0a192f] text-gray-300 pt-[100px]'>
      {/* Container */}
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
        <div>
          <p className='text-4xl font-bold inline border-b-4 border-pink-600'>
            <HighlightText text={"Skills"} />
          </p>
          <p className='py-4 text-white'>
            These are the technologies I've worked with
          </p>
        </div>

        {/* Responsive Grid Layout */}
        <div className='w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 text-center py-8'>
          {[
            { src: HTML, text: 'HTML' },
            { src: CSS, text: 'CSS' },
            { src: JavaScript, text: 'JAVASCRIPT' },
            { src: ReactImg, text: 'REACT' },
            { src: GitHub, text: 'GITHUB' },
            { src: Node, text: 'NODE JS' },
            { src: Mongo, text: 'MONGO DB' },
            { src: Tailwind, text: 'TAILWIND' },
            { src: Express1, text: 'Express js' },
            { src: FireBase, text: 'FIREBASE' },
            { src: Cp, text: 'C++' },
            { src: Dsa1, text: 'Data Structure' }
          ].map((skill, index) => (
            <div key={index} className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
              <img className='w-20 mx-auto' src={skill.src} alt={`${skill.text} icon`} />
              <p className='my-4'>
                <HighlightText text={skill.text} />
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;

